var React = require('react');

function Dark (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"stroke-foreground fill-none","d":"M13.9,2.9C14.6,4.3,15,5.8,15,7.5c0,5.5-4.4,9.9-9.9,9.9\n\t\tc-0.3,0-0.7,0-1,0c1.7,2.4,4.4,3.9,7.6,3.9c5.1,0,9.3-4.2,9.3-9.3C21,7.5,18,3.9,13.9,2.9z"}));
}

Dark.defaultProps = {"version":"1.0","width":"24px","height":"24px","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = Dark;

Dark.default = Dark;
